import { employeeApi } from "../../redux/api/axiosInstance";

export interface Notification {
  notificationId: number;
  employeeId: number;
  userId: string;
  message: string;
  isRead: boolean;
  createdAt: string;
  title?: string;        
  type?: string;
  priority?: "low" | "medium" | "high";
}

export interface PaginatedNotificationResponse {
  data: Notification[];
  totalCount: number;
  pageNo: number;
  pageSize: number;
  totalPages: number;
}

export interface UnreadCountResponse {
  unreadCount: number; // Changed from 'count' to 'unreadCount'
}

const BASE = "Notifications";

const extract = <T>(p: Promise<any>): Promise<T> =>
  p.then(r => r.data).catch((err: any) => {
    const msg =
      err?.response?.data?.message ||
      err?.message ||
      "Notification service error";
    const wrapped = new Error(msg);
    (wrapped as any).status = err?.response?.status;
    throw wrapped;
  });

export const getAllNotifications = (pageNo = 1, pageSize = 10) =>
  extract<PaginatedNotificationResponse>(
    employeeApi.get(`${BASE}/GetAll`, { params: { pageNo, pageSize } })
  );

export const getNotificationById = (notificationId: number) =>
  extract<Notification>(employeeApi.get(`${BASE}/GetById/${notificationId}`));

export const getUnreadNotificationsCount = () =>
  extract<UnreadCountResponse>(employeeApi.get(`${BASE}/GetUnreadCount`));

export const markNotificationAsRead = (notificationId: number) =>
  extract<void>(employeeApi.post(`${BASE}/MarkAsRead/${notificationId}`));

export const markAllNotificationsAsRead = () =>
  extract<void>(employeeApi.post(`${BASE}/MarkAllAsRead`));